import type { ReactNode } from 'react';
import { CircleAlert, CircleCheck, Info, TriangleAlert } from 'lucide-react';
import { cn } from '@/lib/cn';

const TONES = {
  info: { box: 'bg-info-soft text-info', icon: Info },
  success: { box: 'bg-primary-soft text-primary', icon: CircleCheck },
  warning: { box: 'bg-warning-soft text-warning', icon: TriangleAlert },
  danger: { box: 'bg-danger-soft text-danger', icon: CircleAlert },
} as const;

/** Inline message banner ("You have 2 unfinished drafts..."). */
export function Notice({
  tone = 'info',
  title,
  children,
  className,
  role,
}: {
  tone?: keyof typeof TONES;
  title?: ReactNode;
  children?: ReactNode;
  className?: string;
  role?: 'alert' | 'status';
}) {
  const { box, icon: Icon } = TONES[tone];
  return (
    <div role={role} className={cn('flex gap-3 rounded-control px-4 py-3', box, className)}>
      <Icon className="mt-0.5 size-5 shrink-0" strokeWidth={1.9} />
      <div className="min-w-0">
        {title && <p className="font-semibold">{title}</p>}
        {children && <div className={cn(title && 'mt-0.5', 'text-ink-2')}>{children}</div>}
      </div>
    </div>
  );
}
